// IMPORT REACT
import React from "react";
import Axios from "axios";

// IMPORT CONTAINERS
import Layout from '../../Layout';

// IMPORT COMPONENTS
import YAContainer from '../../../components/Grid/Container';
import YASection from '../../../components/Grid/Section';
import YARow from '../../../components/Grid/Row';
import YAColumn from '../../../components/Grid/Column';
import YAText from '../../../components/Text';
import YAInput from '../../../components/Form/Input';
import YAButton from '../../../components/Form/Button';
import YALink from '../../../components/Form/Link';

// IMPORT STYLES
// import {} from '../../styles';

const TermsOfUse = ({ lang, page, bloginfo }) => {
  return (
    <Layout lang={lang} page={page} bloginfo={bloginfo}
      header={
        <Header page={page} bloginfo={bloginfo} />
      }
      body={
        <div>
          <SectionMiddle page={page} />
        </div>
      }
    />
  );
}

const Header = ({ page, bloginfo }) => (
  <div>
    <YARow center>
      <YAColumn size="col-md-8 col-lg-6">
        <YAText tag="h1" bootstrap="display-4 mb-3">
          {page ? page.post_title : null}
        </YAText>
      </YAColumn>
    </YARow>
  </div>
);

const SectionMiddle = ({ page }) => (
  <YASection padding={{'top': '0'}}>
    <YAContainer>
      <YARow center>
        <YAColumn size="col-md-10 col-lg-8">
         
					<YAText tag="div">
						{page ? page['post_content'] : null}
					</YAText>
        </YAColumn>
      </YARow>
    </YAContainer>
  </YASection>
);

export default TermsOfUse;